import React from 'react'
import { useForm } from 'react-hook-form'

import { LntButton, LntForm, LntFormItem, LntModalFooter, LntTextArea } from '@app/components/base'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { LntTextAreaProps } from '@app/components/base/Form/Input/TextArea/types'
import type { CommonTemplatesModalData, CommonTemplatesModalProps } from '../types'

const textAreaCommonProps: LntTextAreaProps = { size: SIZE.large }

// TODO: так как есть похожие элементы возможно можно вынести часть в фабрику или новую сущность
export const CommonTemplatesForm: React.FC<Pick<CommonTemplatesModalProps, 'data' | 'onSubmit'>> = ({
  data,
  onSubmit
}) => {
  const form = useForm<CommonTemplatesModalData>()

  const isValid = form.formState.isValid

  const submitButtonText = data ? 'Сохранить' : 'Добавить'

  const handleSubmit = (dataForm: CommonTemplatesModalData): void => {
    onSubmit(dataForm)
  }

  return (
    <LntForm
      layout='vertical'
      onSubmit={ handleSubmit }
      formInstance={ form }
      preserve={ false }
    >
      <LntFormItem
        name='message'
        defaultValue={ data?.message ?? '' }
        validationOptions={ { rules: { required: true } } }
        className={ styles.commonTemplatesFormItem }
      >
        <LntTextArea
          { ...textAreaCommonProps }
          showCount
          maxLength={ 250 }
          placeholder={ FILTERS_PLACEHOLDERS.additionalInfo }
        />
      </LntFormItem>

      <LntModalFooter>
        <LntButton
          type={ BUTTON_TYPE.primary }
          size={ SIZE.middle }
          htmlType='submit'
          disabled={ !isValid }
        >
          { submitButtonText }
        </LntButton>
      </LntModalFooter>
    </LntForm>
  )
}
